import { render, staticRenderFns } from "./error-config.vue?vue&type=template&id=8c1f0132"
import script from "./error-config.vue?vue&type=script&lang=js"
export * from "./error-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports